/*
 * Module for the Tax Table and Rates' Tax Table Detail page.
*/
rs.module("system_/configuration/taxtablesandrates/estimateddeductionexemptionallowance",

    [
        "controls/data/grid",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (gridModule, eventBanner, visibility) {

        var _executeStateSelectionChanged;
        var _executeFedSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, lrsGridApi, backendUrls) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);
            var asOfDateInput = criteria.js(jsSelectors.asOfDateInput);
            var asOfDateSpinner = criteria.js(jsSelectors.asOfDateSpinner);
            var applyButton = criteria.js(jsSelectors.applyButton);



            // Hook up the 'As of Date' change event
            applyButton.click(_.debounce(function () {

                eventBanner.removeAllMessages();

                if (asOfDateInput.val() != '') {
                    loadDeductionAllowanceGrid();
                }
            }, 500));

            // Load the tax table grid given the 'As of Date'
            function loadDeductionAllowanceGrid() {

                asOfDateSpinner.show();

                gridModule.update(
                    backendUrls.getDeductionAllowancesAsync,
                    {
                        asOfDate: asOfDateInput.val(),
                    },
                    lrsGridApi.agGridApi,
                    function done(gridUpdate) {
                        asOfDateSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);